import {View} from 'MWC';
import tpl from '../templates/desktop/apple-pay';

export default class extends View {
    template = tpl;

    constructor() {
        super();
        this.state = {
            ui: this.uiStates.INITIAL
        };
    }
}
